import { gsap } from "gsap";
import GspAnimate from "../modules/GspAnimate";
const gspAnimate= new GspAnimate();

class SectionPoint {
    init(){
        this.cardPoint=document.querySelectorAll('.card-point');
        gspAnimate.StagerAnimation(this.cardPoint)
    } 
}
export default SectionPoint